import http from "./https";

export const getProductList = async () => {
  const { data } = await http.get("/products/list");
  return data;
};
